// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-overlay[data-v-d11494b8]{background-color:rgba(0,0,5,.75);display:block;height:100%;left:0;opacity:1;position:absolute;top:0;transition:opacity .25s ease-in-out;width:100%;z-index:1}.x-overlay.menu-overlay[data-v-d11494b8]{height:calc(100% + 1px)}.x-overlay.fade-leave-active[data-v-d11494b8]{pointer-events:none}.x-overlay.fade-leave-to[data-v-d11494b8]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
